/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";
import { searchByTableColumns } from "./common";
import swal from 'sweetalert2';
import Swal from "sweetalert2";
window.Swal = swal;

$(function() {
    /**
     * Owner table listing 
     */
    var table = window.$('.ownerTable').DataTable({
        "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
        "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
        processing: true,
        serverSide: false,

        "bJQueryUI": true,
        "ajax": {
            "url": window.$(".ownerTable").attr('link'),
            "type": "GET"
        },
        columns: [
            { data: 'id', name: 'id', "visible": false, },
            { data: 'first_name', name: 'first_name', width:'20%' },
            { data: 'last_name', name: 'last_name', width:'20%' },
            { data: 'email', name: 'email', width:'20%' },
            { data: 'phone_number', name: 'phone_number', width:'20%' },
            { data: 'restaurant_count', name: 'restaurant_count' },
            { data: 'status', name: 'status', orderable: false, className: "status" },
            { data: 'action', name: 'action', orderable: false, searchable: false, width:'10%' },
        ]
    });

    var excluded_columns = [5, 6, 7];
    searchByTableColumns(table, '.ownerTable', excluded_columns);

    // ownerlogin form swal alert
    var formTemplate = $('#owner-login-form-template > .custom-swal').clone()[0];
    $('#owner-login-form-template').remove();

    // window.$(document).on('keypress', '.owner-login', function(e) {
    //     if (e.which == 13) {
    //         triggerConfirmPassword();
    //     }
    // });
    // window.$(document).on('click', '.owner-login', function(e) {
    //     triggerConfirmPassword();
    // });

    // function triggerConfirmPassword() {
    //     alert("test");
    // }
    window.$(document).on('click', '.resend-link', function(e) {
        let ownerId = $(this).attr('ownerId');
        let url = $(this).attr('resendurl');
        window.axios({
                method: "get",
                url: url,
                data: { _token: window.$('meta[name="csrf-token"]').attr('content') }
            })
            .then(function(response) {
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(error => {
                window.toastr.error(error.response.data.message, error.response.statusText);
            })
    });
    window.$(document).on('click', ".owner-login", function(e) {
        let ownerId = $(this).attr('ownerId');
        let restaurantId = $(this).attr('restaurantId');
        let url = $(this).attr('verifyURL');

        Swal.fire({
            title: 'Confirm password',
            html: formTemplate,
            confirmButtonText: 'Login',
            showCancelButton: true,
            focusConfirm: false,
            allowEscapeKey: false,
            backdrop: true,
            allowOutsideClick: false,
            //toast: true,
            customClass: {
                confirmButton: 'ownerLoginBtn'
            },
            showLoaderOnConfirm: true,
            didOpen: function() {
                setTimeout(function() {
                    window.$("#super_admin_pass").removeClass('invalid');
                    window.$('.invalid-feedback-admin').remove();
                }, 200)
            },
            preConfirm: () => {
                if (!$("#super_admin_pass").val()) {
                    window.$("#super_admin_pass").removeClass('invalid');
                    window.$('.invalid-feedback-admin').remove();
                    $("#super_admin_pass").addClass('invalid').after('<div class="invalid-feedback-admin">Enter your password</div>');
                    // Swal.showValidationMessage(
                    //     'Enter your password.'
                    // )
                    return false;
                }
                return window.axios({
                        method: "post",
                        url: url,
                        data: { ownerId: ownerId, restaurantId:restaurantId, q: $("#super_admin_pass").val(), _token: window.$('meta[name="csrf-token"]').attr('content') }
                    })
                    .then(function(response) {
                        return response;
                    })
                    .catch(error => {
                        window.$("#super_admin_pass").removeClass('invalid');
                        window.$('.invalid-feedback-admin').remove();
                        $("#super_admin_pass").addClass('invalid').after('<div class="invalid-feedback-admin">' + error.response.data.message + '</div>');
                        return false;
                        // Swal.showValidationMessage(
                        //     `${error.response.data.message}`
                        // )
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                if (result.value) {
                    window.location = result.value.data.redirectTo;
                }
            }
        })
    });

    // mock AJAX requests for this demo
    var isFakeAjaxRequestSuccessfull = false;

    function simulateAjaxRequest() {
        alert("test");
        return false;
        // "send" the fake AJAX request
        var fakeAjaxRequest = new Promise(function(resolve, reject) {
            setTimeout(function() {
                isFakeAjaxRequestSuccessfull ? resolve() : reject();
                isFakeAjaxRequestSuccessfull = !isFakeAjaxRequestSuccessfull;
                swal.stopLoading();
            }, 200);
        });

        // attach success and error handlers to the fake AJAX request
        fakeAjaxRequest.then(function() {
            // do this if the AJAX request is successfull:
            $('input.invalid').removeClass('invalid');
            $('.invalid-feedback').remove();
        }).catch(function() {
            // do this if the AJAX request fails:
            var errors = {
                username: 'Username is invalid',
                password: 'Password is invalid'
            };
            $.each(errors, function(key, value) {
                $('input[name="' + key + '"]').addClass('invalid').after('<div class="invalid-feedback">' + value + '</div>');
            });
        });
    }
    // window.$(document).on('mouseover', '.restaurant_count_i', function(ev) {
    //     $('.restaurant_tiny_table').stop(true, true).fadeIn();
    // }, function(ev) {
    //     $('.restaurant_tiny_table').stop(true, true).fadeOut();
    // }).mousemove(function(ev) {
    //     $('.restaurant_tiny_table').css({ left: ev.layerX + 10, top: ev.layerY + 10 });
    // });

    const showLoading = function(url) {
        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            showCancelButton: false, // There won't be any cancel button
            showConfirmButton: false,
            html: '<div class="sweet_loader"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><h4>Loading...</h4>',
        });

        // AJAX CALL
        window.axios({
                method: "get",
                url: url,
            })
            .then(function(response) {
                console.log(response.data.data)
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showCancelButton: false, // There won't be any cancel button
                    customClass: {
                        popup: 'restaurant-list-class',
                    },
                    html: `
                    <h4 style="float:left; margin-bottom:30px">Restaurant Details</h4>
                    <table class="table table-bordered restaurant_tiny_table"  style="text-align:left">
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Location</th>
                            <th scope="col">Created At</th>
                            <th scope="col" style="width:109px;">Widget</th>
                            <th scope="col">SMS Enabled</th>
                            <th scope="col">Setting</th>
                        </tr>
                    </thead class="tiny_body">
                    <tbody>
                    ` + response.data.data + `
                    </tbody>
                </table>
                    `,
                });
            })
            // setTimeout(function() {
            //     swal.fire({
            //         icon: 'success',
            //         html: '<h4>Success!</h4>'
            //     });
            // }, 700);
            // Swal.fire({
            //     title: 'Now loading',
            //     allowEscapeKey: false,
            //     allowOutsideClick: false,
            //     timer: 2000,
            //     onOpen: () => {
            //         Swal.showLoading();
            //     }
            // }).then(
            //     () => {},
            //     (dismiss) => {
            //         if (dismiss === 'timer') {
            //             console.log('closed by timer!!!!');
            //             Swal.fire({
            //                 title: 'Finished!',
            //                 type: 'success',
            //                 timer: 2000,
            //                 showConfirmButton: false
            //             })
            //         }
            //     }
            // )
    };
    window.$(document).on('click', '.restaurant_count', function(ev) {
        if ($(this).text() == "0") {
            return false;
        }
        let url = $(this).attr('restaurant_url');
        showLoading(url);
    });

    window.$(document).on('click', '.status_checkbox', function(e) {

        window.$(".error").html('');
        window.toastr.remove();

        var id = window.$(this).closest("tr").attr('id');
        let lastTd = window.$(this).closest("tr").find('td:last-child').find('.owner-login');
        if (typeof id !== "undefined" && id !== '') {
            var ownerStatus = (window.$(this).is(':checked')) ? 'on' : 'off';
            window.axios({
                    method: "post",
                    url: window.$(this).attr('statusUpdate'),
                    data: {
                        'id': id,
                        'ownerStatus': ownerStatus,
                    }
                })
                .then(function(response) {
                    window.toastr.success(response.data.message, response.statusText);
                    if (ownerStatus == 'on') {
                        lastTd.show();
                    } else if (ownerStatus == 'off') {
                        lastTd.hide();
                    }
                })
        }
    });
    /**
     * Employee update 
     */
    window.$(".updateOwner").on('click', function(e) {
        e.preventDefault();
        window.$(".error").html('');
        window.toastr.remove();
        window.$('.updateOwner').attr('disabled', 'disabled');
        window.axios({
                method: "PUT",
                url: window.$(".ownerUpdateForm").attr('action'),
                data: window.$(".ownerUpdateForm").serialize(),
            })
            .then(function(response) {
                window.toastr.success(response.data.message, response.statusText);
                setTimeout(function() {
                    window.location = response.data.redirectTo;
                }, 1000);
            })
            .catch(function(error) {
                window.$('.updateOwner').removeAttr('disabled');
                if (error.response.status == 400) {
                    window.$.each(error.response.data, function(key, value) {
                        window.$('#' + key + '-error').text(value[0]);
                    });
                } else if (error.response.status == 401 || error.response.status == 403) {
                    window.toastr.error(error.response.data.message, error.response.statusText);
                }
            });
        return false;
    });


    /**
     * Save Owner  
     */
    window.$(".saveOwner").on('click', function(e) {
        e.preventDefault();
        window.$(".error").html('');
        window.toastr.remove();
        window.$('.saveOwner').attr('disabled', 'disabled');
        window.axios({
                method: "POST",
                url: window.$(".ownerSaveForm").attr('action'),
                data: window.$(".ownerSaveForm").serialize(),
            })
            .then(function(response) {
                window.toastr.success(response.data.message, response.statusText);
                setTimeout(function() {
                    window.location = response.data.redirectTo;
                }, 1000);
            })
            .catch(function(error) {
                window.$('.updateOwner').removeAttr('disabled');
                if (error.response.status == 400) {
                    window.$.each(error.response.data, function(key, value) {
                        window.$('#' + key + '-error').text(value[0]);
                    });
                } else if (error.response.status == 401 || error.response.status == 403) {
                    window.toastr.error(error.response.data.message, error.response.statusText);
                }
            });
        return false;
    });
    
    window.$(document).on("keypress", "#super_admin_pass", function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13') {
            window.$(".ownerLoginBtn").click();
        }
    });
});
